import { PersonalDetailsDto } from '../../app/models/person/personalDetailsDto';
import { PCSDetailsDto } from '../../app/models/pcsEnrolment/pcsDetailsDto';
import { PcsStatus } from '../../app/models/staticData/pcsStatus';
import { Title } from '../../app/models/staticData/title';
import { TitleEnum } from '../../app/enums/titleEnum';
import { PcsStatusEnum } from '../../app/enums/pcsStatusEnum';
import { formatImcNumber } from '../../app/utils/formatImcNumber';
import { getLocalDate } from '../../app/utils/util';
import registrationFormModel from '../../app/models/pcsEnrolment/registrationFormModel';

const { registrationDetailsFormField, personalDetailsFormField, educationalDetailsFormField } = registrationFormModel;

export function getQualificationYears(startYear: number, lastYear: number) {
  const years = [];
  while (startYear <= lastYear) {
    years.push({ id: startYear.toString(), label: startYear.toString() });
    startYear++;
  }
  return years;
}

export function filterPersonalTitles(titles: Title[]): Title[] {
  const allowed: string[] = Object.values(TitleEnum);
  return titles.filter(title => allowed.includes(title.value.toLowerCase()));
}

export function isImcNumberDisabled(registrationDetails: PCSDetailsDto | null | undefined, pcsStatuses: PcsStatus[] | null | undefined): boolean {
  return Boolean(registrationDetails && registrationDetails.pcsStatusId !== null
    && pcsStatuses?.find(status => status.id === registrationDetails.pcsStatusId)?.code !== PcsStatusEnum.Incomplete);
}

export function getPersonalFormValues(personalDetails: PersonalDetailsDto) {
  const { Title, FirstName, LastName, DOB, Gender, Nationality, MobileNumber } = personalDetailsFormField;

  return {
    [Title.name]: personalDetails.titleId,
    [FirstName.name]: personalDetails.firstName,
    [LastName.name]: personalDetails.lastName,
    [DOB.name]: personalDetails.dateOfBirth && getLocalDate(personalDetails.dateOfBirth),
    [Gender.name]: personalDetails.genderId,
    [Nationality.name]: personalDetails.nationalityId,
    [MobileNumber.name]: personalDetails.mobile
  };
}

export function getEducationFormValues(registrationDetails: PCSDetailsDto, personalDetails: PersonalDetailsDto) {
  const { QualificationCountry, PrimaryMedicalDegreeCollege, OtherPrimaryMedicalDegreeCollege, QualificationYear } = educationalDetailsFormField;
  const { DOB } = personalDetailsFormField;
  return {
    [QualificationCountry.name]: registrationDetails?.qualificationCountryId ?? '',
    [PrimaryMedicalDegreeCollege.name]: registrationDetails?.qualificationInstitutionId ?? '',
    [OtherPrimaryMedicalDegreeCollege.name]: registrationDetails?.qualificationInstitutionOther ?? '',
    [QualificationYear.name]: registrationDetails?.qualificationYear?.toString() ?? '',
    [DOB.name]: personalDetails.dateOfBirth && getLocalDate(personalDetails.dateOfBirth)
  };
}

export function getRegistrationFormValues(registrationDetails: PCSDetailsDto) {
  const { IMCNumber, RegistrationType, Scheme, EngagedInPracticeOfMedicine, Specialty, SubSpecialty, UserConfirmation } = registrationDetailsFormField;

  return {
    [IMCNumber.name]: formatImcNumber(registrationDetails?.imcNumber),
    [RegistrationType.name]: registrationDetails?.registrationTypeId ?? '',
    [Scheme.name]: registrationDetails?.schemeId ?? '',
    [EngagedInPracticeOfMedicine.name]:
      registrationDetails?.engagedInPracticeOfMedicine === false ? '0' : '1',
    [Specialty.name]: registrationDetails?.specialtyId ?? '',
    [SubSpecialty.name]: registrationDetails?.subSpeciality ?? '',
    [UserConfirmation.name]: []
  };
}

